import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-left-s",
  "use": "app-icon-left-s-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"app-icon-left-s\"><path d=\"M16.394 21.13a.9.9 0 00.095-1.161l-.095-.112-7.848-7.849 7.848-7.849a.9.9 0 00.095-1.161l-.095-.112a.9.9 0 00-1.16-.095l-.112.095-8.486 8.486a.9.9 0 00-.095 1.16l.095.112 8.486 8.486a.9.9 0 001.272 0z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol